var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsDesktopBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1324,
    height: 555,
    viewBox: "0 0 1324 555",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1244 40.1524H643C309.972 40.1524 40 270.658 40 555",
    stroke: "#F9F9F9",
    strokeWidth: 80
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1244,
    y: 6,
    width: 80,
    height: 68.3048,
    fill: "#F70303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsDesktopBg);
export default __webpack_public_path__ + "static/media/AboutUs_desktop_bg.5bd5f1e89ba5cc0f0cd955705852cd02.svg";
export { ForwardRef as ReactComponent };